import React, { Fragment } from "react";

// core components
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { KeyboardArrowUp } from "@mui/icons-material";
import {
  Zoom,
  Fab,
  useScrollTrigger,
  CssBaseline,
  Grid,
  Toolbar,
} from "@mui/material";

import Logo from "assets/img/headerAyasa.png";

import {
  headerStyle,
  AppBarStyle,
} from "assets/jss/material-dashboard-react/components/headerStyle.js";

const useStyles = makeStyles(headerStyle);

const NAVY = "#0B2D5C";

const useStyles2 = makeStyles({
  heroTitle: {
    fontWeight: 800,
    fontSize: "2.1rem",
    margin: 0,
    color: NAVY,
  },
});

function ScrollTop(props) {
  const { children, window } = props;
  const classes = useStyles();

  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor",
    );

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <Zoom in={trigger}>
      <div
        onClick={handleClick}
        role="presentation"
        className={classes.rootScrollTop}
      >
        {children}
      </div>
    </Zoom>
  );
}

ScrollTop.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default function HeaderAyasa(props) {
  const classes = useStyles();
  const classes2 = useStyles2();

  return (
    <Fragment>
      <CssBaseline />
      <AppBarStyle>
        <Toolbar>
          <Grid container>
            <Grid item xs={12} md={8}>
              <img
                src={Logo}
                alt="logoheader"
                style={{ width: "100%", height: 90, objectFit: "contain" }}
              />
            </Grid>
            <Grid item xs={12} md={4} sx={{ pt: { xs: 0, md: 3 }, pl: 1 }}>
              <div className={classes2.hero}>
                <h1 className={classes2.heroTitle}>Planes de Asistencia</h1>
              </div>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBarStyle>
      <Toolbar id="back-to-top-anchor" />
      <ScrollTop {...props}>
        <Fab
          className={classes.scrollTop}
          size="small"
          aria-label="scroll back to top"
        >
          <KeyboardArrowUp />
        </Fab>
      </ScrollTop>
    </Fragment>
  );
}
